import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  filterModel: { items: [] }, // The initial filter state
};

const filterDataSlice = createSlice({
  name: 'filterData',
  initialState,
  reducers: {
    setFilterModel: (state, action) => {
      state.filterModel = action.payload; // Update filter model with payload data
    },
    resetFilterModel: (state) => {
      state.filterModel = { items: [] }; // Reset to empty — component decides the default per form type
    },
  },
});

export const { setFilterModel, resetFilterModel } = filterDataSlice.actions;

export default filterDataSlice.reducer;